import { Personalstatus } from '@/modules/ewerp/models/PersonalModels';

export type State = {
  personal: Array<Personalstatus>;
};

export const state: State = {
  personal:
    sessionStorage.getItem('personal') != null && sessionStorage.getItem('personal') !== undefined
      ? JSON.parse(sessionStorage.personal)
      : new Array<Personalstatus>(),
};
